/* Epikura alert: delegated events support Shopify theme editor section reloads. */
(function () {
  if (window.__epikuraAlertInitialized) return;
  window.__epikuraAlertInitialized = true;
  let previousFocus = null;
  function openModal(modal) {
    if (!modal) return;
    previousFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ep-alert-open');
    const close = modal.querySelector('.ep-alert-close');
    if (close) close.focus();
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ep-alert-open');
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    previousFocus = null;
  }
  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-ep-alert-open]');
    if (opener) {
      event.preventDefault();
      openModal(document.getElementById(opener.getAttribute('aria-controls')));
      return;
    }
    const close = event.target.closest('[data-ep-alert-close]');
    if (close) { closeModal(close.closest('[data-ep-alert-modal]')); return; }
    const dismiss = event.target.closest('[data-ep-alert-teaser-close]');
    if (dismiss) { const teaser = dismiss.closest('[data-ep-alert-teaser]'); if (teaser) teaser.hidden = true; }
  });
  document.addEventListener('keydown', function (event) {
    const modal = document.querySelector('[data-ep-alert-modal]:not([hidden])');
    if (!modal) return;
    if (event.key === 'Escape') { event.preventDefault(); closeModal(modal); }
    if (event.key === 'Tab') {
      const els = Array.from(modal.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(el => el.getClientRects().length);
      if (!els.length) return;
      const first=els[0],last=els[els.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-ep-alert-modal]:not([hidden])')) document.body.classList.remove('ep-alert-open');
  });
})();
